import type { ScheduleModeConfig } from '../types';

export const selfScheduleModeConfig: ScheduleModeConfig = {
  key: 'self-schedule',
  navigationStyle: 'tabs',
  steps: [
    { key: 'details', label: 'Details' },
    { key: 'slotSelectionEmail', label: 'Slot selection email' },
    { key: 'communication', label: 'Communication' },
    { key: 'scorecard', label: 'Scorecard' },
  ],
  showSecondaryCta: true,
};
